import { useCallback } from 'react';

const useAllowOnlyAlphanumeric = () => {
    const handleKeyDown = useCallback((event) => {
        const allowedKeys = [
            'Backspace',
            'Tab',
            'ArrowLeft',
            'ArrowRight',
            'Delete',
            'Enter',
            'Home',
            'End',
        ];
        const isAlphanumeric = /^[a-zA-Z0-9]$/.test(event.key);
        const isAllowedKey = allowedKeys.includes(event.key);

        if (!isAlphanumeric && !isAllowedKey) {
            event.preventDefault();
        }
    }, []);

    return handleKeyDown;
}

export default useAllowOnlyAlphanumeric;
